export default {
      id: "password-usage",
      viewBox: "0 0 16 18",
      url: __webpack_public_path__ + "img/icons.f759dcb6.svg#password",
      toString: function () {
        return this.url;
      }
    }